/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export default class AddressInputField extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            value: this.props.value,
        }
    }

    componentWillUpdate(nextProps: any, nextState: any) {
        if ((this.props !== nextProps) && nextProps.value !== undefined)  {
            this.setState({ value: nextProps.value })
        }
    }

    handleChange = (event: any) => {
        this.setState({ value: event.target.value })
        this.props.onChange(event)
    }

    /**
     * On focus set Label element with class 'active'
     */
    focusChange = (event: any) => event.target.previousSibling.classList = 'active'

    render() {
        return (
            <div className={`quote__form__group ${this.props.className}`}>
                <label className={this.props.readOnly ? `active` : ''}>{this.props.children}</label>
                <input
                    name={this.props.name}
                    id={this.props.id}
                    type={this.props.type}
                    placeholder={this.props.placeholder}
                    onChange={this.handleChange}
                    value={this.state.value ? this.state.value : ''}
                    onFocus={this.focusChange}
                    readOnly={this.props.readOnly}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Address/components/AddressInputField.tsx